export const Role = {
  Admin: "admin",
  Student: "student",
  Mentor: "mentor",
  Org: "org",
};
